<template>
<!--  -->
<div class="tagForm tra" :class="{'bdLight-bottom':splitLine}" :mode="option.mode">
	<div class="title boxR tra fSub hover-f-main" :title="$t('cmd108',['点击展开/收起'])" ref="tagFormTitle" @click="modeChange($event)">
		<div class="name cb">
			<span class="text">
				{{title}}
				<slot name="title"></slot>
			</span>
			<div class="tool fR mr2x">
				<slot name="titleTool"></slot>
			</div>
			<Icon name="arrowDouble-d" class="arrow tra w1x h1x" :sizeBase="'xs'" /><!-- fa fa-caret-down--></span>
		</div>
		<div class="cSub mt05x" v-if="titleDesc">{{titleDesc}}</div>
	</div>
	<div class="content">
		<Loading :status="'false'"></Loading>
		<ul v-if="ctrlBtn" class="modeCtrl tra-fast_E">
			<li class="groupView tra-fast_E">
				<button class="edit cMain">{{$t('cmd8',['编辑'])}}</button>
			</li>
			<li class="groupEdit tra-fast_E">
				<button class="cancel cSub">{{$t('cmd85',['取消'])}}</button>
				<button class="save cDanger">{{$t('cmd84',['保存'])}}</button>
			</li>
		</ul>
		<div class="changeGroup tra tra_E"><!-- :class="{mt1x:ctrlBtn==false}"-->
			<div class="content-view">
				<slot></slot>
				<!--
				<table>
					<tbody>
						<tr>
							<th class="cSub">这是名称</th>
							<td>阿苏卡的话卡塞蒂撒娇扩大试点sa</td>
						</tr>
						<tr>
							<th class="cSub">这是名称</th>
							<td>iufyoiuah fgkjfhg</td>
						</tr>
					</tbody>
				</table>
				 -->
			</div>
			<div class="content-edit">
				<slot name="edit"></slot>
				<!--
				<table>
					<tbody>
						<tr>
							<th class="cSub">这是名称</th>
							<td><InputText class="w20x" :addClass="{sizeS:true}" v-model="myData"></InputText></td>
						</tr>
						<tr>
							<th class="cSub">这是名称</th>
							<td><Select :name="'sources'" :list="[]" @Click="" :bindActive="myData" :bindMode="'dispersion'"></Select></td>
						</tr>
						<tr>
							<th class="cSub">这是名称</th>
							<td><InputText class="w20x" :addClass="{sizeS:true}" v-model="myData"></InputText></td>
						</tr>
						<tr>
							<th class="cSub">这是名称</th>
							<td><Select :name="'sources'" :list="[]" @Click="" :bindActive="myData" :bindMode="'dispersion'"></Select></td>
						</tr>
					</tbody>
				</table>
				 -->
			</div>
		</div>
	</div>
</div>
</template>
<script>
import Loading from '@/components/common/ui/Loading'
import {formModeChange} from '@/util/lib.js'

import '@/style/main.scss'
export default{
	name: '',
	components: {Loading},
	props: {
		title: {
			type: String,
			default: ''
		},
		titleDesc: {
			type: String
		},
		mode:{//默认展示形式
			type:String,
			default:"def"
		},
		ctrlBtn: {// 是否显示编辑状态转换按钮
			type: Boolean,
			default: true
		},
		showDetail: {// 是否显示详情
			type: Boolean,
			default: true
		},
		splitLine:{//是否显示下方的间隔线
			type:Boolean,
			default:true
		}
	},
	data () {
		return{
			option:{
				mode:this.mode
			}
		}
	},
	methods: {
		modeChange (e) { // 处理详情面板内的分类内容收起和展开以及编辑状态的控制
      let $root = $(e.currentTarget).parents('.tagForm').first()
			let mode =this.option.mode;
			switch (mode) {
				// case "edit":
				// 	break;
				case 'min':
					this.$emit("SizeCtrl","min");
					$root.attr('mode', 'def')
					$root.children('.content').stop().slideDown(500, 'easeInOutExpo', function () {
						$root.children('.content').css('height', '')// 不清空会残留高度影响内部的高度动画
					});
					this.option.mode="def";
					break
				case 'def':
					this.$emit("SizeCtrl","def");
					$root.attr('mode', 'min')
					$root.children('.content').stop().slideUp(500, 'easeInOutExpo')
					this.option.mode="min";
					break
			}
		}
	},
	created () {},
	mounted () {
		this.show = this.showDetail
		if (this.showDetail == false) {
			this.$refs.tagFormTitle.click()
		}
		// $(document).on("click",".tagForm[mode] .modeCtrl button",function(){//处理详情面板中编辑状态
		// 	if($(this).hasClass("save")==false) formModeChange(this);//保存动作由组件自己触发
		// });
		// $(document).on("click",".tagForm[mode] .content-edit button,.tagForm[mode] .content-edit a",function(){//详情面板中编辑板块里按钮动作需要检查高度并修正
		// 	let $btn=$(this);
		// 	let $group=$btn.parents(".content").first().find(".changeGroup");
		// 	setTimeout(function(){
		// 		$group.css("height",$group.find(".content-edit").innerHeight());
		// 	},500);
		// });
		switch(this.option.mode){
			case "min":
				$(this.$el).children(".content").css({display:"none"});
				break;
		}
	}
}
</script>
<style lang="scss" scoped>
//@import "../../../style/definition.scss";
.tagForm{
	.title{padding:{top:1em;bottom:1em};cursor:pointer;
		.name{position:relative;
			.text{font-size:1.2em;}
			.arrow{margin:{top:-.5em;};position: absolute;top:50%;right:0;}
			// svg{margin:{right:.5em;};position:relative;top:.05em;}
		}
	}
	.content{padding:{bottom:2em;};position:relative;
		.modeCtrl{height:3em;position:relative;
			>*{position:absolute;top:0;right:0;}
			button{padding:{left:1em;right:1em;};line-height:3;}
			.groupEdit{transform:translateX(100%);opacity:0;pointer-events:none;}//display:none;
		}
		.changeGroup{position:relative;
			/*.content-view{@extend %tra;}*/
			.content-edit{position:absolute;top:0;transform:translateX(100%);opacity:0;z-index:1;}
		}
	}
&[mode="def"],&[mode="min"]{
	.modeLinkage{
		input[type="text"]{height:auto;border-color:rgba(#000,0);padding:0;position:relative;top:-.15em;pointer-events:none;box-shadow:none;}
		&.select{pointer-events:none;top:.1em;
			.selectDisplay{padding:{left:0;};border-color:rgba(#000,0);
				.fa{opacity:0;}
			}
		}
	}
}
&[mode="min"]{
	.title .arrow{transform:rotate(-90deg);}
}
&[mode="edit"]{background-color:rgba($yellowLight,.1);
	.title{background-color:$yellowLight;color:#fff;cursor:auto;}
	.modeCtrl{
		.groupView{transform:translateX(-200%);opacity:0;pointer-events:none;}
		.groupEdit{transform:translateX(0);opacity:1;pointer-events:auto;}
	}
	.changeGroup{
		.content-view{transform:translateX(-100%);opacity:0;}
		.content-edit{transform:translateX(0);opacity:1;}
	}
}
	table th,.table-colType1 th{width:15%;}
}
.content{
	max-height: unset !important
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/TagForm.vue